<template>
    <div
        v-bind="$attrs"
        :class="{
            'tw:p-0 tw:m-0': separator,
            'tw:px-4 tw:py-1.5': custom && !paddingless,
            'tw:p-0': custom && paddingless,
            'tw:px-4 tw:py-1.5 tw:text-grey-dark tw:text-sm tw:leading-normal tw:opacity-50 tw:cursor-not-allowed tw:pointer-events-none':
                !separator && !custom && disabled,
            'tw:cursor-pointer tw:px-4 tw:py-1.5 tw:text-grey-dark tw:text-sm tw:leading-normal hover:tw:bg-white-ter hover:tw:text-black':
                !separator && !custom && !disabled,
        }"
        role="listitem"
        @click="handleClick"
    >
        <hr v-if="separator" class="tw:bg-border tw:border-none tw:block tw:h-px tw:my-2" />
        <div v-else class="dropdown-item-content">
            <slot />
        </div>
    </div>
</template>

<script>
import { computed, inject } from 'vue';

/**
 * EDropdownItem - Abstraction wrapper around a custom implementation replicating Buefy's b-dropdown-item
 */
export default {
    name: 'EDropdownItem',
    inheritAttrs: false,
    props: {
        value: {
            type: [String, Number, Boolean, Object, Array],
            default: null,
        },
        separator: {
            type: Boolean,
            default: false,
        },
        custom: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        hasLink: {
            type: Boolean,
            default: false,
        },
        paddingless: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const closeDropdown = inject('closeDropdown', () => {});
        const selectItem = inject('selectItem', null);
        const modelValue = inject('modelValue', null);
        const multiple = inject('multiple', null);

        const isSelected = computed(() => {
            if (!modelValue || !modelValue.value || props.value === null) return false;
            if (multiple && multiple.value) {
                return (
                    Array.isArray(modelValue.value) &&
                    modelValue.value.some(item => JSON.stringify(item) === JSON.stringify(props.value))
                );
            }
            return JSON.stringify(modelValue.value) === JSON.stringify(props.value);
        });

        const handleClick = () => {
            if (props.separator || props.custom || props.disabled) {
                return;
            }

            if (selectItem) {
                selectItem(props.value);
            } else {
                closeDropdown();
            }
        };

        return {
            handleClick,
            isSelected,
        };
    },
};
</script>
